import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from "@angular/forms";
import { PersonSearchService } from "../../../_services/person-search.service";
import { ENTER, COMMA } from "@angular/cdk/keycodes";
import * as _ from 'underscore';

import { LoadingService } from "src/app/_services/loading.service";
import { DataService } from 'src/app/data.service';
import { Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';

import { debounceTime } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';
import { GlobalService } from 'src/app/_services/global.service';
import { SuggestedTitle } from "src/app/openai/suggested-titles/suggested-titles.component";


@Component({
  selector: "app-advance-search",
  templateUrl: "./advance-search.component.html",
  styleUrls: ["./advance-search.component.scss"],
})
export class AdvanceSearchComponent implements OnInit {
  private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;



  // jobTitleInput: FormControl = new FormControl(null);
  // skillsInput: FormControl = new FormControl(null);
  // currentWorkCityInput: FormControl = new FormControl(null);
  // currentWorkCountryInput: FormControl = new FormControl(null);
  // currentWorkLocalityInput: FormControl = new FormControl(null);
  // companyInput: FormControl = new FormControl(null);
  // industryInput: FormControl = new FormControl(null);
  // locationInput: FormControl = new FormControl(null);

  // jobTitleStatus: string = 'Current or Past';

  addOnBlur:  boolean = true
  // requestObject: any = {};
  // jobTitleList: any;
  // separatorKeysCodes: number[] = [ENTER, COMMA];
  // jobTitleTopList: any = [];
  // jobTitleSelectedList: any = [];
  // start: number;
  // currentPage: number;
  // skillsSelectedList: any = [];
  // companySelectedList: any = [];
  // industrySelectedList: any = [];
  // gender: any = [];
  // seniority: any = [];
  // graduationYearSelectedList: any = [];
  // schoolSelectedList: any = [];
  // educationSelectedList: any = [];
  // fieldOfStudySelectedList: any = [];
  // zipCodeSelectedList: any = [];
  // contacts: string;
  // currentWorkCitySelectedList: any = [];
  // currentWorkCountrySelectedList: any = [];
  // currentWorkLocalitySelectedList: any = [];
  // languageSelectedList: any = [];
  // totalCandidatesCount: any = 0
  // skillsList: any;
  // fieldOfStudyInput: any;
  // zipCodeInput: any;
  // companysize: any;
  // graduationYearInput: any;
  // schoolInput: any;
  // educationInput: any;
  // locationSelectedList: any;

  // languageInput: any;
  // languageList: any;
  // currentWorkCityList: any;
  // currentWorkCountryList: any;
  // currentWorkLocalityList: any;
  // companyList: any;
  // industryList: any;
  // fieldOfStudyList: any;
  // zipCodeList: any;
  // companySizeList: any;
  // graduationYearList: any;
  // educationList: any;
  // schoolList: any;
  // locationList: any;


  // companyStatus: string = 'Current or Past';
  // industryStatus: string = 'Current or Past';
  searchKeyword: string;
  totalCandidatesCount: number = 0;
  editQuery: boolean = false;
  success_message: string;
  selectable = true;
  removable = true;


  gender: any = "All";

  candidateshavingmobilenumber: boolean = false
  candidateshavingpersonalemail: boolean = false
  candidateshavingprofessionalemail: boolean = false
  candidateshavingsocialprofiles: boolean = false



  // contacts: string[] = ['All', 'Mobile Number', 'Personal Email', 'Professional Email', 'Social Profiles'];


  seniority: any = [];

  /**
   * Job Title Status Filter for radio button
   */
  jobtitletype: string = 'Current';

  /**
   * Job Title Input for autocomplete
   */
  jobTitleInput: FormControl = new FormControl(null);

  /**
   * Job Title List for autocomplete
   */
  jobTitleList: any = [];

  /**
   * Job Title Selected List for autocomplete
   */
  jobTitleSelectedList: any = [];

  jobTitleTopList: any = [];

  locationInput: FormControl = new FormControl(null);

  locationList: any = [];

  locationSelectedList: any = [];

  locationTopList: any = [];


  // current work city
  currentWorkCityInput: FormControl = new FormControl(null);

  currentWorkCityList: any = [];

  currentWorkCitySelectedList: any = [];

  // current work country
  currentWorkCountryInput: FormControl = new FormControl(null);

  currentWorkCountryList: any = [];

  currentWorkCountrySelectedList: any = [];

  // current work locality
  currentWorkLocalityInput: FormControl = new FormControl(null);

  currentWorkLocalityList: any = [];

  currentWorkLocalitySelectedList: any = [];

  // skills
  skillsInput: FormControl = new FormControl(null);

  skillsList: any = [];

  skillsSelectedList: any = [];

  skillsTopList: any = [];

  // company
  companyInput: FormControl = new FormControl(null);

  companyList: any = [];

  companySelectedList: any = [];

  // industry
  industryInput: FormControl = new FormControl(null);

  industryList: any = [];

  industrySelectedList: any = [];

  industryTopList: any = [];

  industrytype: string = 'Current';

  // field of study
  fieldOfStudyInput: FormControl = new FormControl(null);

  fieldOfStudyList: any = [];

  fieldOfStudySelectedList: any = [];

  fieldOfStudyTopList: any = [];

  // Seniority Level
  seniorityLevelInput: FormControl = new FormControl(null);

  seniorityLevelList: any = [];

  seniorityLevelSelectedList: any = [];
  seniorityInput: any = null

  // education
  educationInput: FormControl = new FormControl(null);

  educationList: any = [];

  educationSelectedList: any = [];

  educationTopList: any = [];

  // zip code
  zipCodeInput: FormControl = new FormControl(null);

  zipCodeList: any = [];

  zipCodeSelectedList: any = [];

  // school
  schoolInput: FormControl = new FormControl(null);

  schoolList: any = [];

  schoolSelectedList: any = [];

  schoolTopList: any = [];

  // company size
  companySizeInput: FormControl = new FormControl(null);

  companySizeList: any = [];

  companySizeSelectedList: any = [];

  companysize: any = [];

  companyTopList: any = [];

  companytype: string = 'Current';

  companySizeOption: any = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]

  // graduation year
  graduationYearInput: FormControl = new FormControl(null);

  graduationYearList: any = [];

  graduationYearSelectedList: any = [];


  separatorKeysCodes: number[] = [ENTER, COMMA];

  pageNumber: number = 1;
  pageSize: number = 10;
  currentPage: number = 1;
  start: any //- start number for pagination (from)
  end: any //- end number for paginatuin (to)

  isInsightsActive: boolean = true;
  isListingActive: boolean = false;

  candidateList: any = [];

  requestObject: any;

  reportsAggs: any;
  dataSourceCurrentCompany: any = [];
  dataSourceFunctions: any = [];
  dataSourceWorkCountry: any = [];
  dataSourcePastCompany: any = [];
  dataSourceSkills: any = [];
  dataSourceCurrentJobTitle: any = [];
  dataSourcePastJobTitle: any = [];
  dataSourceGender: any = [];
  dataSourceSeniority: any = [];
  aggregations: any = [];
  dataSourceYearsOfExperience: any = [];

  languageInput: FormControl = new FormControl(null);

  languageList: any = [];

  languageSelectedList: any = [];

  languageTopList: any = [];

  yearsofexperience: any = 'Past';

  yearsofexperienceFrom: FormControl = new FormControl(null);

  yearsofexperienceTo: FormControl = new FormControl(null);





  currentyearsofexperienceFrom: FormControl = new FormControl(null);

  currentyearsofexperienceTo: FormControl = new FormControl(null);




  fromgraduationyears: String
  tograduationyears: String


  fromyearsofexperience: number
  toyearsofexperience: number



  currentfromyearsofexperience: number
  currenttoyearsofexperience: number

  @Output() dataEvent = new EventEmitter<string>();
  socialprofiles: any;
  professionalemail: any;
  personalemail: any;
  mobilenumber: any;

  totalCandidatesCountLoading: boolean = false
  experiencetype: string = 'Total';
  graduationError: boolean = false;

  //
  toExperienceNotNumberError : boolean = false
  fromExperienceNotNumberError : boolean = false

   showJobTitleLoader :boolean =false
   showSkillLoader :boolean =false
   showIndustryLoader:boolean= false
   showLocationLoader:boolean=false
   showCompanyLoader:boolean=false
   showEducationLoader:boolean=false
   showFieldOfStudyLoader:boolean=false
   showSchoolLoader:boolean=false
   totaldatacount: any
   @Input() events: Observable<void>;
     // Functions Filter
   functionsInput: FormControl = new FormControl(null)
   functionsList: any = []
   showFunctionsLoader: boolean = false
   functionSelectedList: any = []
   seniorityList= GlobalService.seniorityLevels;

   //name filter
   nameInput: FormControl = new FormControl(null)
   showfullnameLoader: boolean = false
   fullnameList: any
   fullnameSelectedList: any = [];

   savedHistorySubject : Subject<any> = new Subject<any>();

  // Constant to access in template
  PAST_JOB_TITLE = "pastjobtitle";
  pastJobTitleInput: FormControl = new FormControl(null);
  pastJobTitleTopList: any;
  pastJobTitleSelectedList: any[] = [];
  pastJobTitleList: any = [];
  showPastJobTitleLoader: boolean = false;

   private continent?: string[];

  isOpenAIPastJobTitleLoading: boolean = false;
  showOpenAIPastJobTitleSuggestions: number;

  get openAIPastJobTitles() {
    return this.pastJobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  isOpenAITitleLoading: boolean = false;
  showOpenAITitleSuggestions: number;

  get openAITitles(): string {
    return this.jobTitleSelectedList.filter(jt => !jt.isSuggestion).map(jobTitle => `"${jobTitle.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  isOpenAISkillsLoading: boolean = false;
  showOpenAISkillsSuggestions: number;

  get openAISkills(): string {
    return this.skillsSelectedList.filter(jt => !jt.isSuggestion).map(skill => `"${skill.key.replace('.searchastext', '')}"`).join(' OR ') || '';
  }

  get openAIAll(): string {
    return [this.openAITitles, this.openAISkills, this.openAIPastJobTitles].filter(s => s).join(' OR ') || '';
  }

  get selectedContinent() {
    return this.continent || [this.localstorageservice.getItem('region')];
  }


  schoolLocationInput: FormControl = new FormControl(null);
  schoolLocationList: any = [];
  schoolLocationSelectedList: any = [];
  schoolLocationTopList: any = [];
  showSchoolLocationLoader = false;
  distanceform: FormControl = new FormControl(null, [Validators.pattern("^[0-9]*$"), Validators.min(0), Validators.max(500)]);
  distancetype: FormControl = new FormControl(null);

  constructor(private router: Router, private personSearchService: PersonSearchService, private Loadingservice: LoadingService, private dataService: DataService,
    private localstorageservice: LocalStorageService) {}

  ngOnInit() {
    this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.callTypeAheadSearch(event, type);
    });

    this.distancetype.patchValue('kilometers');
    this.distanceform.patchValue(20);
    console.log("distance", this.distanceform)
/**
 * commented for testing
 */
    //this.getAllFilters();



    // this.Loadingservice.stopLoading();


    this.requestObject = {
      startindex: this.start,
      resultsize: 20,
      searchviaboolean: true,
      booleanquery: "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList.map(jobTitle => jobTitle.key),
      preferredskills: this.skillsSelectedList.map(skill => skill.key),
      mandatoryskills: [],
      locations: [],
      companies: this.companySelectedList.map(c => c.key),
      industries: this.industrySelectedList.map(industry => industry.key),
      exclusionlist: [],
      genders: this.gender != '' ? this.gender && this.gender.length ? [this.gender] : [] : [],
      // seniority: [this.seniority],
      seniority: this.seniority.length? this.seniority : [],
      graduationyear: this.graduationYearSelectedList.map(gy => gy.key),
      schools: this.schoolSelectedList.map(s => s.key),
      schooltypes: [],
      educationaldegrees: this.educationSelectedList.map(e => e.key),
      educationalmajors: this.fieldOfStudySelectedList.map(fs => fs.key),
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: this.zipCodeSelectedList.map(z => z.key),
      // companysizes: this.companysize ? [this.companysize] : [],
      companysizes: this.companysize.length ? this.companysize : [],
      candidateshavingcontacts: false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: [],
      input:'',
      continentstobeincluded: this.selectedContinent,
      functions: this.functionSelectedList.map(fn => fn.key),
      searchedfrom: 'advanced-search',
      fetchtotalpersoncountincontinent: true,
      distancefromselectedlocations: this.distanceform.value,
      distancefromselectedlocationsmeasurementunit: this.distancetype.value


      // fromgraduationyears:this.fromgraduationyears != null ? [this.fromgraduationyears] : [],
      // tograduationyears: this.tograduationyears != null ? [this.tograduationyears] : []
    }
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    this.totalCandidatesCountLoading = true;
    this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.totalCandidatesCountLoading = false;
        this.totalCandidatesCount = response.data.totalresultscount;
      }
    })

    this.events.subscribe((res:any)=>{
      this.continent = [res];
      this.requestObject['continentstobeincluded'] = this.selectedContinent;
      const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
      //loadn[0].style.display = 'none'
      this.totalCandidatesCountLoading = true;
      this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
        if (response.status == 'success') {
          this.totalCandidatesCountLoading = false;
          this.totalCandidatesCount = response.data.totalresultscount;
        }
      })
    })


 }

  typeAheadSearch(event, type: string) {
    if(this.requestObject && this.requestObject['aggregatetype']){
      delete this.requestObject['aggregatetype']
    }

    const searchValue = (event.target as HTMLInputElement).value.trim();

    switch (type) {
      case 'jobtitle': {
        this.requestObject['typeahead'] = this.jobtitletype == 'Current or Past' ? 'typeahead_jobtitle' : this.jobtitletype == 'Current' ? 'typeahead_currentjobtitle' : 'typeahead_pastjobtitle';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this. showJobTitleLoader = true
          this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle').subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.jobTitleList = response.data;
              this.showJobTitleLoader = false
            }
          });
        }

        break;
      }
      case 'currentworkcity': {
        this.requestObject['typeahead'] = this.jobtitletype == 'All' ? 'typeahead_workregion' : 'typeahead_currentworkregion';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.currentWorkCityList = response.data;
          }
        });
      }
        break;
      }
      case 'currentworkcountry': {
        this.requestObject['typeahead'] = this.jobtitletype == 'All' ? 'typeahead_workcountry' : 'typeahead_currentworkcountry';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.currentWorkCountryList = response.data;
          }
        });
      }
        break;
      }
      case 'currentworklocality': {
        this.requestObject['typeahead'] = this.jobtitletype == 'All' ? 'typeahead_worklocality' : 'typeahead_currentworklocality';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.currentWorkLocalityList = response.data;
          }
        });
      }
        break;
      }
      case 'skills': {
        this.requestObject['typeahead'] = 'typeahead_skills';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this.showSkillLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'skill').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsList = response.data;
            this.showSkillLoader = false
          }
        });
      }
        break;
      }
      case 'company': {
        this.requestObject['typeahead'] = this.companytype == 'Current or Past' ? 'typeahead_company' : this.jobtitletype == 'Current' ? 'typeahead_currentcompany' : 'typeahead_pastcompany';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this.showCompanyLoader=true
        this.personSearchService.getPersonSearchListing(searchValue, 'company').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            const companyList = response.data;
            this.personSearchService.getCompanyLogo({ companynames: companyList.map(c => c.value)}).subscribe((response: any) => {
              this.companyList = response.message;
              this.showCompanyLoader=false;
            });
          }
        });
      }
        break;
      }
      case 'industry': {
        this.requestObject['typeahead'] = this.industrytype == 'Current or Past' ? 'typeahead_industry' : this.industrytype == 'Current' ? 'typeahead_currentindustry' : 'typeahead_pastindustry';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this.showIndustryLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'industry').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.industryList = response.data;
            this.showIndustryLoader = false
          }
        });
      }
        break;
      }
      case 'fieldofstudy': {
        this.requestObject['typeahead'] = 'typeahead_fieldofstudy';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {

          this.showFieldOfStudyLoader=true

        this.personSearchService.getPersonSearchListing(searchValue, 'fieldofstudy').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.fieldOfStudyList = response.data;
            this.showFieldOfStudyLoader=false
          }
        });
      }
        break;
      }
      case 'zipcode': {
        this.requestObject['typeahead'] = 'typeahead_zipcode';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.zipCodeList = response.data;
          }
        });
      }
        break;
      }
      case 'companysize': {
        this.requestObject['typeahead'] = this.jobtitletype == 'All' ? 'typeahead_companysize' : 'typeahead_currentcompanysize';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            const rangeValue = (range) => {
              const match = range.match(/(\d+)/g);
              const start = parseInt(match[0]);
              const end = parseInt(match[1]);
              return Math.floor(start / 10);
            };

            this.companySizeList = response.data.sort((a, b) => {
              const aValue = rangeValue(a.key);
              const bValue = rangeValue(b.key);
              return aValue - bValue;
            });
          }
        });
      }
        break;
      }
      case 'graduationyear': {
        this.requestObject['typeahead'] = 'typeahead_graduationyear';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.graduationYearList = response.data;
          }
        });
      }
        break;
      }
      case 'education': {
        this.requestObject['typeahead'] = 'typeahead_education';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this.showEducationLoader=true
        this.personSearchService.getPersonSearchListing(searchValue, 'education').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.educationList = response.data;
            this.showEducationLoader=false
          }
        });
      }
        break;
      }
      case 'school': {
        this.requestObject['typeahead'] = 'typeahead_school';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this.showSchoolLoader=true
        this.personSearchService.getPersonSearchListing(searchValue, 'school').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.schoolList = response.data;
            this.showSchoolLoader=false
          }
        });
      }
        break;
      }
      case 'location': {
        this.requestObject['typeahead'] = 'typeahead_location';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
          this.showLocationLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'location',  this.requestObject['continentstobeincluded']).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.locationList = response.data;
          this.showLocationLoader = false
        }
        });
      }
        break;
      }
      case this.PAST_JOB_TITLE: {
        this.requestObject['typeahead'] = 'typeahead_pastjobtitle';
        this.requestObject['input'] = searchValue;
        if (this.requestObject['input'].length > 2) {
          this.showPastJobTitleLoader = true;
          this.personSearchService.getPersonSearchListing(searchValue, this.PAST_JOB_TITLE).subscribe((response: any) => {
            if (response.status == 'success' && response.data) {
              this.pastJobTitleList = response.data;
            }
            this.showPastJobTitleLoader = false;
          });
        }
        break;
      }
      case 'language': {
        this.requestObject['typeahead'] = 'typeahead_spokenlanguage';
        this.requestObject['input'] = searchValue;
        if(this.requestObject['input'].length > 2) {
        this.personSearchService.getPersonSearchListing(searchValue).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.languageList = response.data;
        }
        });
      }
        break;
      }

      case 'fromgraduationyears': {
        this.graduationError = false
        const year = parseInt(searchValue);
        if (isNaN(year) || searchValue.length !== 4) {
          console.error("Invalid 'from' graduation year. Please enter a valid four-digit year between 1900 and the current year.");
          if(searchValue == ''){
            this.getPersonSearchRecommendedCandidates();
          }else{
            this.graduationError = true;
          }
          return;
        }else{
          this.fromgraduationyears = searchValue
          this.getPersonSearchRecommendedCandidates();
        }

        break;
      }

      case 'tograduationyears': {

        this.graduationError = false
        const year = parseInt(event.target.value);

        if (isNaN(year) || event.target.value.length !== 4) {
          if(event.target.value == ''){
            this.getPersonSearchRecommendedCandidates();
          }else{
            // If the entered value is not a valid four-digit year or falls outside the acceptable range, show an error.
            console.error("Invalid 'to' graduation year. Please enter a valid four-digit year between 1900 and the current year.");
            this.graduationError = true;

          }
          return;
        }else{
          this.tograduationyears = event.target.value;
          this.getPersonSearchRecommendedCandidates();
        }

        break;
      }


      case 'fromyearsofexperience': {
        const fromYears = this.yearsofexperienceFrom.value
        if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
            this.fromyearsofexperience = fromYears;
            if (!isNaN(this.toyearsofexperience) && this.fromyearsofexperience > this.toyearsofexperience) {
                console.error("fromyearsofexperience should be greater than toyearsofexperience");
                this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
                break;
            }
            this.yearsofexperienceFrom.setErrors(null);
            this.getPersonSearchRecommendedCandidates();
        }else {
          if(event.target.value == ''){
            this.yearsofexperienceFrom.setErrors(null);
            this.fromyearsofexperience = null
            this.getPersonSearchRecommendedCandidates();
          }else{
              //this.toExperienceNotNumberError = true
              this.yearsofexperienceFrom.setErrors({ 'invalidYears': true });
          }
        }
        break;
    }

    case 'toyearsofexperience': {
        const toYears = this.yearsofexperienceTo.value
        if (!isNaN(toYears) && Number.isInteger(toYears)) {
            this.toyearsofexperience = toYears;
            if (!isNaN(this.fromyearsofexperience) && this.toyearsofexperience <= this.fromyearsofexperience) {
                console.error("toyearsofexperience should be greater than fromyearsofexperience");
                 this.yearsofexperienceTo.setErrors({ 'invalidYears': true });
                break;
            }
            this.yearsofexperienceTo.setErrors(null);
            this.getPersonSearchRecommendedCandidates();
        }else {
          if(event.target.value == ''){
            this.yearsofexperienceTo.setErrors(null);
            this.toyearsofexperience = null
            this.getPersonSearchRecommendedCandidates();
          }else{
            this.yearsofexperienceTo.setErrors({ 'invalidYears': true });
            this.fromExperienceNotNumberError = true
          }
        }
        break;
    }

    case 'functions': {
      this.requestObject['typeahead'] = 'typeahead_function';
      this.requestObject['input'] = searchValue;
      if(this.requestObject['input'].length > 2) {
        this.showFunctionsLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'function').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.functionsList = response.data;
            this.showFunctionsLoader = false
          }
        });
      }

      break;
    }

    case 'fullname': {
      this.requestObject['typeahead'] = 'typeahead_fullname';
      this.requestObject['input'] = searchValue;
      if(this.requestObject['input'].length > 2) {
        this.showfullnameLoader = true
        this.personSearchService.getPersonSearchListing(searchValue, 'fullname').subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.fullnameList = response.data;
            this.showfullnameLoader = false
          }
        });
      }

      break;
    }

    case 'currentfromyearsofexperience': {
      const fromYears = this.currentyearsofexperienceFrom.value
      if (!isNaN(fromYears) && Number.isInteger(fromYears)) {
          this.currentfromyearsofexperience = fromYears;
          if (!isNaN(this.currenttoyearsofexperience) && this.currentfromyearsofexperience > this.currenttoyearsofexperience) {
              console.error("currentfromyearsofexperience should be greater than currenttoyearsofexperience");
              this.currentyearsofexperienceFrom.setErrors({ 'invalidYears': true });
              break;
          }
          this.currentyearsofexperienceFrom.setErrors(null);
          this.getPersonSearchRecommendedCandidates();
      }else {
        if(event.target.value == ''){
          this.currentyearsofexperienceFrom.setErrors(null);
          this.currentfromyearsofexperience = null
          this.getPersonSearchRecommendedCandidates();
        }else{
            //this.toExperienceNotNumberError = true
            this.currentyearsofexperienceFrom.setErrors({ 'invalidYears': true });
        }
      }
      break;
  }

  case 'currenttoyearsofexperience': {
    const toYears = this.currentyearsofexperienceTo.value
    if (!isNaN(toYears) && Number.isInteger(toYears)) {
        this.currenttoyearsofexperience = toYears;
        if (!isNaN(this.currenttoyearsofexperience) && this.currenttoyearsofexperience <= this.currentfromyearsofexperience) {
            console.error("currenttoyearsofexperience should be greater than currentfromyearsofexperience");
             this.currentyearsofexperienceTo.setErrors({ 'invalidYears': true });
            break;
        }
        this.currentyearsofexperienceTo.setErrors(null);
        this.getPersonSearchRecommendedCandidates();
    }else {
      if(event.target.value == ''){
        this.currentyearsofexperienceTo.setErrors(null);
        this.currenttoyearsofexperience = null
        this.getPersonSearchRecommendedCandidates();
      }else{
        this.currentyearsofexperienceTo.setErrors({ 'invalidYears': true });
        this.fromExperienceNotNumberError = true
      }
    }
    break;
  }
  case 'schoollocation': {
    this.requestObject['typeahead'] = 'typeahead_schoollocation';
    this.requestObject['input'] = searchValue;
    if (this.requestObject['input'].length > 2) {
      this.showSchoolLocationLoader = true;
      this.personSearchService.getPersonSearchListing(searchValue, 'school_location').subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.schoolLocationList = response.data;
        }
        this.showSchoolLocationLoader = false;
      });
    }
    break;
  }
  case 'distance' : {
    console.log(event);
    this.distanceform.patchValue(event.target.value);
    this.getPersonSearchRecommendedCandidates();
    break;
  }
  case 'distancetype' : {
    console.log(event);
    this.distancetype.patchValue(event.target.value);
    this.getPersonSearchRecommendedCandidates();
    break;
  }



    }
  }

  getCompanyLogoForCompanyChips(companyList: Array<string>) {  
    if(!companyList || !companyList.length) return;
    const updatedCompanyList = companyList.map(companyName => {
      const name = companyName.split(".searchastext");
      return name[0];
    }).filter(Boolean);
    
    this.personSearchService.getCompanyLogo({ companynames: updatedCompanyList }).subscribe((res: any) => {
      this.companySelectedList?.length && this.companySelectedList.map(company => {
        if (res && res.message?.length) {
          res.message.map(logosData => {
            if ((logosData.key === company.chipkey) || (logosData.key === company.key) ) {
              company['companylogo'] = logosData?.companylogo;
            }
          })
        }
      })
    })
  }


  companySizeHandler(event){
    let value = event.value;
    this.companysize = _.without(this.companysize, "All")
    value = _.without(value, "All")
    if(value.length == 8){
      this.companysize= value;
      this.companysize.push("All");
    }else{
      this.companysize = value;
    }
     this.getPersonSearchRecommendedCandidates();
  }

    seniorityHandler(event){
      let value = event.value;
      this.seniority = _.without(this.seniority, "All")
      value = _.without(value, "All")
      if(value.length == 10){
        this.seniority = value;
        this.seniority.push("All")
      }else{
        this.seniority = value;
      }
      this.getPersonSearchRecommendedCandidates();
    }

  selectedItem(event, type, contactEvent: any = null) {
    this.start = 0;
    this.currentPage = 1;
    const inputElements: NodeListOf<Element> = document.querySelectorAll(".mat-input-element");
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case "jobtitle": {
        this.jobTitleList = []
        if (event.option && event.option.value) {
          this.jobTitleSelectedList.push({
            ...event.option.value,
            isExcluded: false,
            isMandatory: false,
            chipkey: event.option.value.key
          });
        } else {
          this.jobTitleSelectedList.push({
            key: event.target.value + ".searchastext",
            isExcluded: false,
            isMandatory: false,
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, "key");
        this.jobTitleInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case this.PAST_JOB_TITLE: {
        this.pastJobTitleList = []
        if (event.option && event.option.value) {
          this.pastJobTitleSelectedList.push({
            ...event.option.value,
            isExcluded: false,
            isMandatory: false,
            chipkey: event.option.value.key
          });
        } else {
          this.pastJobTitleSelectedList.push({
            key: event.target.value + ".searchastext",
            isExcluded: false,
            isMandatory: false,
            chipkey: event.target.value
          });
          this.autocomplete.closePanel();
        }

        this.pastJobTitleSelectedList = _.uniq(this.pastJobTitleSelectedList, "key");
        this.pastJobTitleInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'currentworkcity': {
        this.currentWorkCitySelectedList.push(event.option.value);
        this.currentWorkCitySelectedList = _.uniq(this.currentWorkCitySelectedList, 'key');
        this.currentWorkCityInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'currentworkcountry': {
        this.currentWorkCountrySelectedList.push(event.option.value);
        this.currentWorkCountrySelectedList = _.uniq(this.currentWorkCountrySelectedList, 'key');
        this.currentWorkCountryInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'currentworklocality': {
        this.currentWorkLocalitySelectedList.push(event.option.value);
        this.currentWorkLocalitySelectedList = _.uniq(this.currentWorkLocalitySelectedList, 'key');
        this.currentWorkLocalityInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'skills': {
        this.skillsList = []
        if (event.option && event.option.value) {
          this.skillsSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.skillsSelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'key');
        this.skillsInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'company': {
        this.companyList = []
        if (event.option && event.option.value) {
          this.companySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.companySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.companySelectedList = _.uniq(this.companySelectedList, 'key');
        this.getCompanyLogoForCompanyChips(_.pluck(this.companySelectedList,'key'))
        this.companyInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'industry': {
        this.industryList = []
        if (event.option && event.option.value) {
          this.industrySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.industrySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'key');
        this.industryInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'fieldofstudy': {
        this.fieldOfStudyList = []
        if (event.option && event.option.value) {
          this.fieldOfStudySelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.fieldOfStudySelectedList.push({ key: event.target.value + ".searchastext", chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'key');
        this.fieldOfStudyInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'zipcode': {
        this.zipCodeSelectedList.push(event.option.value);
        this.zipCodeSelectedList = _.uniq(this.zipCodeSelectedList, 'key');
        this.zipCodeInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'companysize': {
        this.companySizeHandler(event)
        break;
      }
      case 'graduationyear': {
        this.graduationYearSelectedList.push(event.option.value);
        this.graduationYearSelectedList = _.uniq(this.graduationYearSelectedList, 'key');
        this.graduationYearInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'school': {
        this.schoolList = []
        if (event.option && event.option.value) {
          this.schoolSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.schoolSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'key');
        this.schoolInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'education': {
        this.educationList = []
        if (event.option && event.option.value) {
          this.educationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.educationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.educationSelectedList = _.uniq(this.educationSelectedList, 'key');
        this.educationInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'gender': {
        this.gender = event;
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'seniority': {
        this.seniorityHandler(event)
        break;
      }
      case 'contacts': {
        this[event] = contactEvent.target.checked
        if (event == 'candidateshavingsocialprofiles') {
          this.getAggregationReport('socialprofiles');
        } else if (event == 'candidateshavingprofessionalemail') {
          this.getAggregationReport('professionalemail');
        } else if (event == 'candidateshavingpersonalemail') {
          this.getAggregationReport('personalemail');
        } else if (event == 'candidateshavingmobilenumber') {
          this.getAggregationReport('mobilenumber');
        }

        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'location': {
        this.locationList = []
        if (event.option && event.option.value) {
          this.locationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.locationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
        this.locationInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'language': {
        this.languageSelectedList.push(event.option.value);
        this.languageSelectedList = _.uniq(this.languageSelectedList, 'key');
        this.languageInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'functions': {
        this.functionsList = []
        if (event.option && event.option.value) {
          this.functionSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.functionSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.functionSelectedList = _.uniq(this.functionSelectedList, 'key');
        this.functionsInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'fullname': {
        this.fullnameList = []
        if (event.option && event.option.value) {
          this.fullnameSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.fullnameSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.fullnameSelectedList = _.uniq(this.fullnameSelectedList, 'key');
        this.nameInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'schoollocation': {
        this.schoolLocationList = []
        if (event.option && event.option.value) {
          this.schoolLocationSelectedList.push({ ...event.option.value, chipkey: event.option.value.key })
        } else {
          this.schoolLocationSelectedList.push({ key: event.target.value + '.searchastext', chipkey: event.target.value })
          this.autocomplete.closePanel();
        }
        this.schoolLocationSelectedList = _.uniq(this.schoolLocationSelectedList, 'key');
        this.schoolLocationInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }
    }
  }

  addToSelectedList(item, type) {
    switch (type) {
      case 'jobtitle': {
        this.jobTitleSelectedList.push({...item, isExcluded: false, isMandatory: false});
        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, 'key');
        this.jobTitleInput.reset();
        this.getPersonSearchRecommendedCandidates();
        break;
      }

      // case 'location': {
      //   this.locationSelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.locationSelectedList = _.uniq(this.locationSelectedList, 'key');
      //   this.locationInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
      // case 'skills': {
      //   this.skillsSelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'key');
      //   this.skillsInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
      // case 'company': {
      //   this.companySelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.companySelectedList = _.uniq(this.companySelectedList, 'key');
      //   this.companyInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
      // case 'industry': {
      //   this.industrySelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.industrySelectedList = _.uniq(this.industrySelectedList, 'key');
      //   this.industryInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
      // case 'fieldofstudy': {
      //   this.fieldOfStudySelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'key');
      //   this.fieldOfStudyInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
      // case 'school': {
      //   this.schoolSelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'key');
      //   this.schoolInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
      // case 'language': {
      //   this.languageSelectedList.push({...item, isExcluded: false, isMandatory: false});
      //   this.languageSelectedList = _.uniq(this.languageSelectedList, 'key');
      //   this.languageInput.reset();
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      // }
    }
  }


  getPersonSearchRecommendedCandidates() {

    this.requestObject = {
      startindex: this.start,
      resultsize: 20,
      searchviaboolean: true,
      booleanquery: "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: this.jobTitleSelectedList.map(jobTitle => jobTitle.key),
      pastjobtitles: _.uniq(this.pastJobTitleSelectedList.filter(jobTitle => !jobTitle.isExcluded).map(j => j.key)),
      exclude_pastjobtitles: _.uniq(this.pastJobTitleSelectedList.filter(jobTitle => !!jobTitle.isExcluded).map(j => j.key)),
      preferredskills: this.skillsSelectedList.map(skill => skill.key),
      mandatoryskills: [],
      companies: this.companySelectedList.map(c => c.key),
      industries: this.industrySelectedList.map(industry => industry.key),
      exclusionlist: [],
      genders: this.gender != '' ? this.gender && this.gender.length ? [this.gender] : [] : [],
      seniority: this.seniority.length? this.seniority : [],
      graduationyear: this.graduationYearSelectedList.map(gy => gy.key),
      schools: this.schoolSelectedList.map(s => s.key),
      schooltypes: [],
      educationaldegrees: this.educationSelectedList.map(e => e.key),
      educationalmajors: this.fieldOfStudySelectedList.map(fs => fs.key),
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: this.zipCodeSelectedList.map(z => z.key),
      companysizes: this.companysize.length ? this.companysize : [],
      candidateshavingcontacts: false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: [],
      candidateshavingmobilenumber: this.candidateshavingmobilenumber,
      candidateshavingpersonalemail : this.candidateshavingpersonalemail,
      candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
      candidateshavingsocialprofiles : this.candidateshavingsocialprofiles,
      // fromgraduationyears:this.fromgraduationyears != null ? [this.fromgraduationyears] : [],
      // tograduationyears: this.tograduationyears != null ? [this.tograduationyears] : [],
      companytype: this.companytype == 'Current or Past' ? 'All' : this.companytype,
      jobtitletype: this.jobtitletype == 'Current or Past' ? 'All' : this.jobtitletype,
      industrytype: this.industrytype == 'Current or Past' ? 'All' : this.industrytype,
      experiencetype: this.experiencetype,
      fromyearsofexperience: this.fromyearsofexperience != null ?  [this.fromyearsofexperience] : [],
      toyearsofexperience: this.toyearsofexperience != null ? [this.toyearsofexperience] : [],
      locations: this.locationSelectedList.map(l => l.key),
      continentstobeincluded: this.selectedContinent,
      functions: this.functionSelectedList.map(fn => fn.key),
      fullnames: this.fullnameSelectedList.map(nm => nm.key),
      searchedfrom: 'advanced-search',
      currentfromyearsofexperience: this.currentfromyearsofexperience != null ?  [this.currentfromyearsofexperience] : [],
      currenttoyearsofexperience: this.currenttoyearsofexperience != null ? [this.currenttoyearsofexperience] : [],

      schoollocation: _.uniq(this.schoolLocationSelectedList.filter(jobTitle => !jobTitle.isExcluded).map(j => j.key)),
      exclude_schoollocation: _.uniq(this.schoolLocationSelectedList.filter(jobTitle => !!jobTitle.isExcluded).map(j => j.key)),
      needcuratedtalentpooltags: true,
      distancefromselectedlocations: this.distanceform.value,
      distancefromselectedlocationsmeasurementunit: this.distancetype.value

    }
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'block'

    this.totalCandidatesCountLoading = true;
    this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
      if (response.status == 'success') {
        this.totalCandidatesCountLoading = false;
        this.totalCandidatesCount = response.data.totalresultscount;
        // this.jobTitleList = response.data.aggregations.current_jobtitle
        // this.industryList = response.data.aggregations.current_industry
        // this.skillsList = response.data.aggregations.skills
        // this.locationList = response.data.aggregations.location
        // this.companyList = response.data.aggregations.company
        // this.educationList = response.data.aggregations.education
        // this.fieldOfStudyList = response.data.aggregations.fieldofstudy
        // this.schoolList = response.data.aggregations.school

        // this.socialprofiles = response.data.aggregations.socialprofiles
        // this.professionalemail = response.data.aggregations.professionalemail
        // this.personalemail = response.data.aggregations.personalemail
        // this.mobilenumber = response.data.aggregations.mobilenumber
      }
    });
  }

  filterByStatus(event, type) {
    if(event.target.value == 'Current or Past'){
      event.target.value = 'All'
    }
    switch (type) {
      case 'jobtitle': {
        this.jobtitletype = event.target.value;
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'company': {
        this.companytype = event.target.value;
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'industry': {
        this.industrytype = event.target.value;
        this.getPersonSearchRecommendedCandidates();
        break;
      }
      case 'experiencetype':{
        this.experiencetype = event.target.value;
        this.getPersonSearchRecommendedCandidates();
        break;

      }
    }
  }

  removeChip(value, type) {
    this.start = 0;
    this.currentPage = 1;
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case this.PAST_JOB_TITLE:
        this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'currentworkcity':
        this.currentWorkCitySelectedList = this.currentWorkCitySelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'currentworkcountry':
        this.currentWorkCountrySelectedList = this.currentWorkCountrySelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'currentworklocality':
        this.currentWorkLocalitySelectedList = this.currentWorkLocalitySelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'company':
        this.companySelectedList = this.companySelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'industry':
        this.industrySelectedList = this.industrySelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'fieldofstudy':
        this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'zipcode':
        this.zipCodeSelectedList = this.zipCodeSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      // case 'companysize':
      //   this.companySizeSelectedList = this.companySizeSelectedList.filter(item => item.key !== value.key);
      //   this.getPersonSearchRecommendedCandidates();
      //   break;
      case 'graduationyear':
        this.graduationYearSelectedList = this.graduationYearSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'school':
        this.schoolSelectedList = this.schoolSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'education':
        this.educationSelectedList = this.educationSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'location':
        this.locationSelectedList = this.locationSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'language':
        this.languageSelectedList = this.languageSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'functions':
        this.functionSelectedList = this.functionSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'fullname':
        this.fullnameSelectedList = this.fullnameSelectedList.filter(item => item.key !== value.key);
        this.getPersonSearchRecommendedCandidates();
        break;
      case 'companysize':
        if(value === "All"){
          this.companysize = [];
        }else{
          this.companysize = this.companysize.filter(item => item !==value);
        }
        this.getPersonSearchRecommendedCandidates();
        break;
        case 'seniority':
          if(value === "All"){
            this.seniority = [];
          }else{
            this.seniority = this.seniority.filter(item => item !==value);
          }
        this.getPersonSearchRecommendedCandidates();
        break;  
      case 'schoollocation':
      this.schoolLocationSelectedList = this.schoolLocationSelectedList.filter(item => item.key !== value.key);
      this.getPersonSearchRecommendedCandidates();
      break;  

    }
  }

  getAllFilters(){
    this.requestObject = {
      startindex: this.start,
      resultsize: 10,
      searchviaboolean: false,
      booleanquery: "*",
      iscurrent: false,
      currentcompaniesonly: false,
      pastcompaniesonly: false,
      jobtitles: [],
      preferredskills: [],
      mandatoryskills: [],
      locations: [],
      companies: [],
      industries: [],
      exclusionlist: [],
      genders: [],
      seniority: [],
      graduationyear: [],
      schools: [],
      schooltypes: [],
      educationaldegrees: [],
      educationalmajors: [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: [],
      companysizes: this.companysize ? [this.companysize] : [],
      candidateshavingcontacts: false,
      workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      spokenlanguages: this.languageSelectedList.map(l => l.key),
      contacts: [],
      candidateshavingmobilenumber: this.candidateshavingmobilenumber,
      candidateshavingpersonalemail : this.candidateshavingpersonalemail,
      candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
      candidateshavingsocialprofiles : this.candidateshavingsocialprofiles,
      continentstobeincluded: this.selectedContinent,
      functions: []

      // fromgraduationyears:[],
      // tograduationyears: []
    }
    this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
      if (response.status == 'success') {

        this.totalCandidatesCount = response.data.totalresultscount
        this.jobTitleList = response.data.aggregations.jobtitle
        this.industryList = response.data.aggregations.industry
        this.skillsList = response.data.aggregations.skills
        this.locationList = response.data.aggregations.location
        this.companyList = response.data.aggregations.company
        this.educationList = response.data.aggregations.education
        this.fieldOfStudyList = response.data.aggregations.fieldofstudy
        this.schoolList = response.data.aggregations.school

        this.socialprofiles = response.data.aggregations.socialprofiles
        this.professionalemail = response.data.aggregations.professionalemail
        this.personalemail = response.data.aggregations.personalemail
        this.mobilenumber = response.data.aggregations.mobilenumber
        this.functionsList = response.data.aggregations.functions
        const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
        //loadn[0].style.display = 'none'
        this.getTotalAggs();
      }
    });
  }

  sendDataToParent() {

  //  const contactsAvailableArray = [
  //     { key: 'Personal Email', doc_count: this.personalemail.doc_count },
  //     { key: 'Professional/Work Email', doc_count: this.professionalemail.doc_count },
  //     { key: 'Mobile Number', doc_count: this.mobilenumber.doc_count },
  //     { key: 'Social Profiles', doc_count: this.socialprofiles.doc_count },
  //   ];

  const contactsAvailableArray = [];

  if (this.personalemail && this.personalemail.hasOwnProperty('doc_count')) {
    contactsAvailableArray.push({
      key: 'Personal Email',
      doc_count: this.personalemail.doc_count,
    });
  }

  // Similarly, you can do the same for other properties and add them to the array.
  // For example:
  if (this.professionalemail && this.professionalemail.hasOwnProperty('doc_count')) {
    contactsAvailableArray.push({
      key: 'Current Professional Email',
      doc_count: this.professionalemail.doc_count,
    });
  }

  if (this.mobilenumber && this.mobilenumber.hasOwnProperty('doc_count')) {
    contactsAvailableArray.push({
      key: 'Mobile Number',
      doc_count: this.mobilenumber.doc_count,
    });
  }

  if (this.socialprofiles && this.socialprofiles.hasOwnProperty('doc_count')) {
    contactsAvailableArray.push({
      key: 'Social Profiles',
      doc_count: this.socialprofiles.doc_count,
    });
  }


    const contactSelectedList = []

    // candidateshavingmobilenumber: this.candidateshavingmobilenumber,
    // candidateshavingpersonalemail : this.candidateshavingpersonalemail,
    // candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
    // candidateshavingsocialprofiles : this.candidateshavingsocialprofiles,

  if (this.candidateshavingpersonalemail && this.candidateshavingpersonalemail == true) {
    contactSelectedList.push({
      key: 'Personal Email',
      doc_count: this.personalemail.doc_count,
    });
  }

  // Similarly, you can do the same for other properties and add them to the array.
  // For example:
  if (this.candidateshavingprofessionalemail && this.candidateshavingprofessionalemail == true) {
    contactSelectedList.push({
      key: 'Current Professional Email',
      doc_count: this.professionalemail.doc_count,
    });
  }

  if (this.candidateshavingmobilenumber && this.candidateshavingmobilenumber == true) {
    contactSelectedList.push({
      key: 'Mobile Number',
      doc_count: this.mobilenumber.doc_count,
    });
  }

  if (this.candidateshavingsocialprofiles && this.candidateshavingsocialprofiles == true) {
    contactSelectedList.push({
      key: 'Social Profiles',
      doc_count: this.socialprofiles.doc_count,
    });
  }




  //   const contactSelectedList = [
  //     { key: 'Personal Email', doc_count: 0 },
  //     { key: 'Current Professional Email', doc_count: 0 },
  //     { key: 'Mobile Number', doc_count: this.mobilenumber.doc_count },
  //     { key: 'Social Profiles', doc_count: 0 },
  //   ]

    this.skillsSelectedList = this.skillsSelectedList.map(item => {
      return {
          ...item,
          isMandatory: false,
          isSuggested: item.isSuggestion
      };
    });

    this.companySelectedList = this.companySelectedList.map(item => {
      return {
        ...item,
        isExcluded: false
      };
    })

    this.locationSelectedList = this.locationSelectedList.map(item => {
      return {
        ...item,
        isExcluded: false
      };
    })


    const allLists = {
      jobTitleSelectedList: this.jobTitleSelectedList.map(j => ({ ...j, isSuggested: j.isSuggestion })),
      skillsSelectedList: this.skillsSelectedList,
      industrySelectedList: this.industrySelectedList,
      locationSelectedList: this.locationSelectedList,
      companySelectedList: this.companySelectedList,
      educationSelectedList: this.educationSelectedList,
      fieldOfStudySelectedList: this.fieldOfStudySelectedList,
      schoolSelectedList: this.schoolSelectedList,
      gender: this.gender,
      // yearsofgraduationFrom: this.fromgraduationyears,
      // yearsofgraduationTo: this.tograduationyears,
      contactsAvailableArray: contactsAvailableArray,
      contactSelectedList: contactSelectedList,
      yearsofexperienceFrom: this.fromyearsofexperience,
      yearsofexperienceTo: this.toyearsofexperience,
      companyStatus: this.companytype && this.companytype.toString().toLocaleLowerCase() === 'all' ? 'Current or Past' : this.companytype,
      jobTitleStatus: this.jobtitletype && this.jobtitletype.toString().toLocaleLowerCase() === 'all' ? 'Current or Past' : this.jobtitletype,
      industryStatus: this.industrytype && this.industrytype.toString().toLocaleLowerCase() === 'all' ? 'Current or Past' : this.industrytype,
      yearsofexperience: this.experiencetype,
      companysize : this.companysize,
      functionSelectedList: this.functionSelectedList,
      seniority: this.seniority,
      fullnameSelectedList: this.fullnameSelectedList,
      currentfromyearsofexperience: this.currentfromyearsofexperience,
      currenttoyearsofexperience: this.currenttoyearsofexperience,
      pastJobTitleSelectedList: this.pastJobTitleSelectedList.map(j => ({ ...j, isSuggested: j.isSuggestion })),
      schoolLocationSelectedList: this.schoolLocationSelectedList,
      distancefromselectedlocations: this.distanceform.value,
      distancefromselectedlocationsmeasurementunit: this.distancetype.value
    };


    const data = {
      allLists,
      requestObject: this.requestObject,
      calledFrom: 'advance',
    }

    this.dataService.setData(data);
    this.router.navigate(['/person/search/listing'], { queryParams: { keyword: '', type: 'advanced-search' } });
  }



    private callTypeAheadSearch(event: Event, type: string) {
      this.typeAheadSearch(event, type);
    }


    // Call this function whenever the user types something
    onTypeAheadSearch(event: Event, type: string) {
      // Emit the event and type as an object through the typeAheadSubject to apply debounce
      this.typeAheadSubject.next({ event, type });
    }


    clearFilters(){

      this.totalCandidatesCount = 0
      this.jobTitleSelectedList = []
      this.pastJobTitleSelectedList = []
      this.skillsSelectedList = []
      this.industrySelectedList = []
      this.locationSelectedList = []
      this.companySelectedList = []
      this.educationSelectedList = []
      this.fieldOfStudySelectedList = []
      this.schoolSelectedList = []
      this.functionSelectedList = []
      this.fullnameSelectedList = []
      this.gender = 'All'
      this.candidateshavingmobilenumber = null
      this.candidateshavingpersonalemail = null
      this.candidateshavingprofessionalemail = null
      this.candidateshavingsocialprofiles = null

      this.jobtitletype = 'Current'
      this.experiencetype = 'Total'
      this.companytype = 'Current'
      this.industrytype = 'Current'


      this.fromyearsofexperience = null
      this.toyearsofexperience = null
      this.yearsofexperienceFrom.patchValue(null)
      this.yearsofexperienceTo.patchValue(null)


      // this.fromgraduationyears = null
      // this.tograduationyears = null

      this.companysize = [];
      this.seniority = [],
      this.distanceform.patchValue(20);
      this.distancetype.patchValue('kilometers');


      this.requestObject = {
          startindex: this.start,
          resultsize: 20,
          searchviaboolean: false,
          booleanquery: "*",
          iscurrent: false,
          currentcompaniesonly: false,
          pastcompaniesonly: false,
          jobtitles: [],
          preferredskills: [],
          mandatoryskills: [],
          companies: [],
          industries: [],
          exclusionlist: [],
          genders: [],
          seniority: [],
          graduationyear: [],
          schools: [],
          schooltypes: [],
          educationaldegrees: [],
          educationalmajors:[],
          candidateshavingemails: false,
          candidateshavingcontactnumbers: false,
          minexperience: null,
          maxexperience: null,
          minexperienceinccurrentcompany: null,
          zipcodes: [],
          companysizes: [],
          candidateshavingcontacts: false,
          workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
          workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
          worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
          spokenlanguages: this.languageSelectedList.map(l => l.key),
          contacts: [],
          candidateshavingmobilenumber: this.candidateshavingmobilenumber,
          candidateshavingpersonalemail : this.candidateshavingpersonalemail,
          candidateshavingprofessionalemail: this.candidateshavingprofessionalemail,
          candidateshavingsocialprofiles : this.candidateshavingsocialprofiles,
          jobtitletype : 'Current',
          experiencetype : 'Total',
          companytype : 'Current',
          industrytype : 'Current',
          fromyearsofexperience: [],
          toyearsofexperience: [],
          locations: [],
          continentstobeincluded: this.selectedContinent,
          functions: [],
          fullnames: [],
          currentfromyearsofexperience: [],
          currenttoyearsofexperience: [],
          fromgraduationyears:[],
          tograduationyears: [],
          distancefromselectedlocations: this.distanceform.value,
          distancefromselectedlocationsmeasurementunit: this.distancetype.value
      }

      // this.getrecordcount(); This is an older API for total count now we don`t need to use this API.

      this.totalCandidatesCountLoading = true;
      this.personSearchService.getPersonSearchRecommendCandidates(this.requestObject).subscribe(response => {
        if (response.status == 'success') {
          this.totalCandidatesCountLoading = false;
          this.totalCandidatesCount = response.data.totalresultscount;
        }
      });

    }

    // not in indian format
    formatNumberToIndianFormat(number) {
      if(number){
        const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
        for (const suffix of suffixes) {
          if (Math.abs(number) < 1000) {
            return Math.floor(number) + suffix;
          }
          number /= 1000;
        }
        return Math.floor(number) + 'T';
      }else{
        return 0;
      }
    }

    getTotalAggs(){
      this.getAggregationReport('gender');
      this.getAggregationReport('company');
      // this.getAggregationReport('current_company');
      this.getAggregationReport('pastcompany');
      // this.getAggregationReport('seniority');
      this.getAggregationReport('school');
      this.getAggregationReport('current_industry');
      this.getAggregationReport('pastindustry');
      this.getAggregationReport('industry');
      this.getAggregationReport('current_jobtitle');
      this.getAggregationReport('pastjobtitle');
      this.getAggregationReport('jobtitle');
      this.getAggregationReport('skills');
      this.getAggregationReport('fieldofstudy');
      this.getAggregationReport('education');
      // this.getAggregationReport('location');
      // this.getAggregationReport('current_companysizes');
      // this.getAggregationReport('companysizes');
      this.getAggregationReport('mobilenumber');
      this.getAggregationReport('professionalemail');
      this.getAggregationReport('personalemail');
      this.getAggregationReport('socialprofiles');
      // this.getAggregationReport('graduationyear');
      // this.getAggregationReport('totalyearsofexperience');
      // this.getAggregationReport('currentyearsofexperience');
      // this.getAggregationReport('averageyearsofexperience');
      // this.getAggregationReport('likelytomove');
      // this.getAggregationReport('contactsavailability');
      // this.getAggregationReport('zipcodes');
    }



    getAggregationReport(aggregatetype: string) {
      this.requestObject['aggregatetype'] = aggregatetype;
      this.personSearchService.getTotalAggs(this.requestObject).subscribe(response => {
          if (response.status == 'success') {
            this.jobTitleList = this.jobTitleList === undefined ? response.data.aggregations.current_jobtitle : this.jobTitleList;
            this.industryList = this.industryList === undefined ? response.data.aggregations.current_industry : this.industryList;
            this.skillsList = this.skillsList === undefined ? response.data.aggregations.skills : this.skillsList;
            this.locationList = this.locationList === undefined ? response.data.aggregations.location : this.locationList;
            this.companyList = this.companyList === undefined ? response.data.aggregations.company : this.companyList;
            this.educationList = this.educationList === undefined ? response.data.aggregations.education : this.educationList;
            this.fieldOfStudyList = this.fieldOfStudyList === undefined ? response.data.aggregations.fieldofstudy : this.fieldOfStudyList;
            this.schoolList = this.schoolList === undefined ? response.data.aggregations.school : this.schoolList;

            this.socialprofiles = this.socialprofiles === undefined ? response.data.aggregations.socialprofiles : this.socialprofiles;
            this.professionalemail = this.professionalemail === undefined ? response.data.aggregations.professionalemail : this.professionalemail;
            this.personalemail = this.personalemail === undefined ? response.data.aggregations.personalemail : this.personalemail;
            this.mobilenumber = this.mobilenumber === undefined ? response.data.aggregations.mobilenumber : this.mobilenumber;

          }
      });
  }

  getrecordcount() {
    this.personSearchService.getrecordsCount().subscribe((res:any)=>{
      this.totalCandidatesCount = res.data;
    })
  }

  checkHistory(event){
    if(event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    }
  }

  openaiTitleLoading({ state, count }) {
    this.isOpenAITitleLoading = state;
    this.showOpenAITitleSuggestions = count;
  }

  setTitleSuggestions(suggestions: SuggestedTitle[]) {
    // generate key for each suggestion
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.searchastext.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    // existing suggestions
    const existingSuggestions = this.jobTitleSelectedList.filter(suggestion => suggestion.isSuggestion);
    // remove existing suggestions from new suggestions
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    // add new suggestions to existing suggestions
    this.jobTitleSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.getPersonSearchRecommendedCandidates();
    }
  }

  openaiSkillsLoading({ state, count }) {
    this.isOpenAISkillsLoading = state;
    this.showOpenAISkillsSuggestions = count;
  }

  setSkillsSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.searchastext.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'skill', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.skillsSelectedList.filter(suggestion => suggestion.isSuggestion);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    this.skillsSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.getPersonSearchRecommendedCandidates();
    }
  }

  openaiPastJobTitleLoading({ state, count }) {
    this.isOpenAIPastJobTitleLoading = state;
    this.showOpenAIPastJobTitleSuggestions = count;
  }

  setPastJobTitleSuggestions(suggestions: SuggestedTitle[]) {
    const suggestionsWithKey = suggestions.map(suggestion => {
      return {
        key: `${suggestion.name}.searchastext.aisearch`,
        chipkey: suggestion.name,
        isExcluded: false,
        isMandatory: false,
        isSuggestion: true,
        suggestedTitle: { name: suggestion.name, selected: true, type: 'title', key: this.getSafeKey(suggestion.name) }
      };
    });
    const existingSuggestions = this.pastJobTitleSelectedList.filter(suggestion => suggestion.isSuggestion);
    const newSuggestions = suggestionsWithKey.filter(suggestion => !existingSuggestions.find(existingSuggestion => existingSuggestion.chipkey === suggestion.chipkey));
    this.pastJobTitleSelectedList.push(...newSuggestions);
    if (newSuggestions.length) {
      this.getPersonSearchRecommendedCandidates();
    }
  }
  
  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleList = []
        }
        break;
      }
      case 'skills': {
        if (!(this.skillsInput && this.skillsInput.value && this.skillsInput.value.length >= maxLength)) {
          this.skillsList = []
        }
        break;
      }
      case 'company': {
        if (!(this.companyInput && this.companyInput.value && this.companyInput.value.length >= maxLength)) {
          this.companyList = []
        }
        break;
      }
      case 'industry': {
        if (!(this.industryInput && this.industryInput.value && this.industryInput.value.length >= maxLength)) {
          this.industryList = []
        }
        break;
      }
      case 'fieldofstudy': {
        if (!(this.fieldOfStudyInput && this.fieldOfStudyInput.value && this.fieldOfStudyInput.value.length >= maxLength)) {
          this.fieldOfStudyList = []
        }
        break;
      }
      case 'education': {
        if (!(this.educationInput && this.educationInput.value && this.educationInput.value.length >= maxLength)) {
          this.educationList = []
        }
        break;
      }
      case 'school': {
        if (!(this.schoolInput && this.schoolInput.value && this.schoolInput.value.length >= maxLength)) {
          this.schoolList = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationList = []
        }
        break;
      }
      case 'pastjobtitle': {
        if (!(this.pastJobTitleInput && this.pastJobTitleInput.value && this.pastJobTitleInput.value.length >= maxLength)) {
          this.pastJobTitleList = []
        }
        break;
      }
      case 'functions': {
        if (!(this.functionsInput && this.functionsInput.value && this.functionsInput.value.length >= maxLength)) {
          this.functionsList = []
        }
        break;
      }
      case 'fullname': {
        if (!(this.nameInput && this.nameInput.value && this.nameInput.value.length >= maxLength)) {
          this.fullnameList = []
        }
        break;
      }
      case 'schoollocation': {
        if (!(this.schoolLocationInput && this.schoolLocationInput.value && this.schoolLocationInput.value.length >= maxLength)) {
          this.schoolLocationList = []
        }
        break;
      }
    }
  }
  
  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }
  
  capitalizeFirstLetter(continent: any = []) {
    if(continent && continent !== null && continent !== undefined && continent.length >= 1 && Array.isArray(continent)){
      const continentValue = continent[0] 
      return continentValue.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
  }
}
